
// Returns a point by its original index, before sorting by date.
export default function getPoint(series, index) {
  return series[0].hasOwnProperty('index') ?
    series.find(item => item.index === index)
    :
    series[index];
}



// WEBPACK FOOTER //
// ./src/chart/data/getPoint.js